// extracted by mini-css-extract-plugin
export default {"ancestry":"tags-ancestry_ancestry__HNdlO","ancestor":"tags-ancestry_ancestor__PIe8C","title":"tags-ancestry_title__wOT51","ancestor__chunk":"tags-ancestry_ancestor__chunk__pkuag"};